import React from 'react';
import type {QueryFilterAdapterModel, QueryFilterAdapterProps, QueryFilterProps} from '@igp/shared/components/filter';
import {withQueryFilter} from '@igp/shared/components/filter';
import type {CountryFilterSharedProps} from '@igp/shared/features/country';
import type {EntityType} from '@models';

import type {
    CountryLevelPartnerReportFilterName,
    CountryLevelPartnerReportFilterViewModel,
    CountryLevelPartnerReportQueryFilterKeys,
} from '../types';

import {CountryLevelPartnerReportFilters} from './Filters';

type CountryLevelPartnerReportFiltersAdapterProps = QueryFilterAdapterProps<
    CountryLevelPartnerReportQueryFilterKeys,
    CountryLevelPartnerReportFilterName,
    never
> &
    CountryFilterSharedProps<EntityType>;

function CountryLevelPartnerReportFiltersAdapter({model, onChange, ...props}: CountryLevelPartnerReportFiltersAdapterProps) {
    const filterViewModel: CountryLevelPartnerReportFilterViewModel = {
        countries: model?.country as string[],
        date: {
            from: model?.date_from as number,
            to: model?.date_to as number,
        },
    };

    function handleChange(model: CountryLevelPartnerReportFilterViewModel) {
        const result: QueryFilterAdapterModel<CountryLevelPartnerReportQueryFilterKeys, never> = {
            country: model?.countries,
            date_from: model?.date?.from,
            date_to: model?.date?.to,
        };
        onChange(result);
    }

    return <CountryLevelPartnerReportFilters model={filterViewModel} onChange={handleChange} {...props} />;
}

export const CountryLevelPartnerReportQueryFilters: React.ComponentType<
    QueryFilterProps<CountryLevelPartnerReportQueryFilterKeys, CountryLevelPartnerReportFilterName> & CountryFilterSharedProps<EntityType>
> = withQueryFilter<
    CountryLevelPartnerReportQueryFilterKeys,
    CountryLevelPartnerReportFilterName,
    never,
    CountryFilterSharedProps<EntityType>
>(CountryLevelPartnerReportFiltersAdapter, {});
